import initCatalog from './common-catalog';

$(() => {
    initCatalog();
});

export default () => {
    $.ajaxSetup({
        data: { csrf_token: '<?= bitrix_sessid() ?>' },
        beforeSend(xhr, settings) {
            if (settings.url.startsWith('/api/')) {
                xhr.setRequestHeader('X-Language-Id', '<?= LANGUAGE_ID ?>');
            }
        },
    });
};
